module.exports = __webpack_public_path__ + "static/media/planet-proof.a91be620.svg";